import { FC } from "react";
import { Col, Row } from "taltech-styleguide";
import Tooltip from "react-bootstrap/Tooltip";
import { OverlayTooltip } from "./OverlayTooltip";
import { BuildingSpecParameter, ParametersTable } from "./ParametersTable";
import { CreationTypeEnum } from "./BuildingSpecificationForm";

type Props = {
  data: any;
  buildingParameters: BuildingSpecParameter[];
};

export const BuildingInfoComponent: FC<Props> = ({
  data,
  buildingParameters,
}) => {
  return (
    <div className="build-spec-section">
      <div className="section-header">
        <h5>Building Info</h5>
      </div>
      <div className="section-body">
        <Row>
          <Col xs="9">
            <label>
              <span>Building Type:</span>
            </label>
          </Col>
          <Col xs="3">
            {data.height.value.creationType === CreationTypeEnum.RANDOM ? (
              <img
                src={"/Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            ) : (
              <img
                src={"/Not_Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col xs="9">
            <label>
              <span>Orientation:</span> {`${data.orientation.angle.value}°`}
            </label>
          </Col>
          <Col xs="3">
            {data.orientation.angle.creationType === CreationTypeEnum.RANDOM ? (
              <img
                src={"/Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            ) : (
              <img
                src={"/Not_Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col xs="9">
            <label>
              <span>Modular:</span> {data.isModular ? "Yes" : "No"}
            </label>
          </Col>
          <Col xs="3">
            <img
              src={"/Not_Random.svg"}
              alt={"success Shuffle"}
              className={"ebd-shuffle-btn"}
            />
          </Col>
        </Row>
        <Row>
          <Col xs="9">
            <label>
              <span>Height:</span> {`${data.height.value.value} m`}
            </label>
          </Col>
          <Col xs="3">
            {data.height.value.creationType === CreationTypeEnum.RANDOM ? (
              <img
                src={"/Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            ) : (
              <img
                src={"/Not_Random.svg"}
                alt={"success Shuffle"}
                className={"ebd-shuffle-btn"}
              />
            )}
          </Col>
        </Row>

        <Row className="mt-3">
          <div style={{ width: "fit-content" }}>
            <OverlayTooltip
              data={{
                creationType: "RANDOM",
                parameters: buildingParameters,
              }}
              component={DynamicTooltip}
            >
              <span>Building parameters presets used</span>
            </OverlayTooltip>
          </div>
        </Row>
      </div>
    </div>
  );
};

const DynamicTooltip = ({ creationType, parameters }: any) => (
  <Tooltip style={{ position: "fixed" }}>
    <ParametersTable
      creationType={creationType}
      parameters={parameters}
    ></ParametersTable>
  </Tooltip>
);
